import appCreateStyles from '@material-ui/styles/createStyles'

export { appCreateStyles }
